import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';
import { OnboardingContainerComponent } from '../../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe, ButtonComponent, DecimalPipe, IconComponent, NgbTooltipModule],
  templateUrl: './top-3-issuer.component.html',
  styleUrl: './top-3-issuer.component.scss',
})
export class Top3IssuerComponent {
  readonly #router = inject(Router);

  public readonly issuers: Issuer[] = [
    {
      name: 'Amundi',
      ter: 0.12,
      isin: 'IE000BI8OT95',
      mostPopular: true,
    },
    {
      name: 'Xtrackers',
      ter: 0.19,
      isin: 'IE00BJ0KDQ92',
      mostPopular: false,
    },
    {
      name: 'iShares',
      ter: 0.2,
      isin: 'IE00B4L5Y983',
      mostPopular: false,
    },
  ];

  public goBack = () => this.#navigate(commonRoutes.postlogin.onboarding.savingsPlan.favoriteSuggestions);
  public selectIssuer = (issuer: Issuer) => this.#navigate(`${commonRoutes.postlogin.onboarding.savingsPlan.create}/${issuer.isin}`);
  readonly #navigate = (route: string) => this.#router.navigateByUrl(route);
}

interface Issuer {
  name: string;
  ter: number;
  isin: string;
  mostPopular: boolean;
}
